var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpiritsAndLiquor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Cocktail-Glass-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Cocktail Glass 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.45a1 1 0 0 0 -1 -1.15h-2a0.5 0.5 0 0 1 -0.38 -0.17 0.53 0.53 0 0 1 -0.12 -0.4l0.14 -1a0.49 0.49 0 0 1 0.31 -0.4 2.48 2.48 0 0 0 1.56 -2.3 2.51 2.51 0 0 0 -1.24 -2.13l0.22 -1.72a1 1 0 1 0 -2 -0.26l-0.23 1.75a2.48 2.48 0 0 0 -0.8 4.33 0.51 0.51 0 0 1 0.19 0.46l-0.19 1.4a0.51 0.51 0 0 1 -0.5 0.43H5a1 1 0 0 0 -0.76 0.35 1 1 0 0 0 -0.23 0.81l1.7 10.66A3.43 3.43 0 0 0 9 24h6a3.43 3.43 0 0 0 3.29 -2.83Zm-2.74 0.85a0.49 0.49 0 0 1 0.38 0.17 0.49 0.49 0 0 1 0.12 0.4l-0.31 2a0.51 0.51 0 0 1 -0.5 0.43h-0.65a0.49 0.49 0 0 1 -0.38 -0.17 0.49 0.49 0 0 1 -0.12 -0.4l0.28 -2a0.49 0.49 0 0 1 0.49 -0.43Zm-3.71 0a0.5 0.5 0 0 1 0.5 0.57l-0.28 2a0.5 0.5 0 0 1 -0.49 0.43H7.09a0.51 0.51 0 0 1 -0.5 -0.42l-0.32 -2a0.55 0.55 0 0 1 0.11 -0.41 0.52 0.52 0 0 1 0.38 -0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpiritsAndLiquor);
export default ForwardRef;